import { isValidLeader } from './isValidLeader'

const VOUCHERS = [10, 12, 15, 20]

export function getVoucherAmount({ leader }, colleagueCount) {
  if (!isValidLeader(leader)) return 0
  const voucherPerContact = VOUCHERS[colleagueCount - 1]
  return voucherPerContact * (colleagueCount + 1)
}
